<template>
	<div>
		<div style="display: flex;justify-content: space-between;">
			<div>
				<v-radio-group v-model="selectedStatus" row>
					<v-radio
						v-for="text in [ACTIVE, INACTIVE]"
						:key="text"
						:label="text"
						:value="text"
						@change="handleChange"
					></v-radio>
				</v-radio-group>
			</div>
			<div class="pa-1" @click="openDialog('add')">
				<v-btn color="info">Add Notification</v-btn>
			</div>
		</div>
		<div
			v-for="item in selectedStatus === ACTIVE
				? activeAlerts
				: inActiveAlerts"
			:key="item.id"
		>
			<v-card class="pa-2 mb-4">
				<div style="display:flex;">
					<div>
						<div class="pa-2">
							<span class="font-weight-bold">Title:</span>
							{{ item.title }}
						</div>
						<div class="pa-2">
							<span class="font-weight-bold">Body:</span>
							{{ item.body }}
						</div>
						<div class="pa-2">
							<span class="font-weight-bold">Start Time:</span>
							{{ new Date(item.startTime).toLocaleString() }}
						</div>
						<div class="pa-2">
							<span class="font-weight-bold">End Time:</span>
							{{ new Date(item.endTime).toLocaleString() }}
						</div>
					</div>
					<div
						v-if="selectedStatus === ACTIVE"
						style="align-self:center"
						@click="openDialog('edit', item)"
					>
						<v-icon color="#000" style="cursor: pointer"
							>chevron_edit</v-icon
						>
					</div>
				</div>
			</v-card>
		</div>
		<div style="display: flex;justify-content: center" class="mb-2">
			<v-icon
				v-if="offset"
				color="#000"
				style="cursor: pointer"
				@click="changeOffset('dec', selectedStatus)"
				>chevron_left</v-icon
			><v-icon
				v-if="
					(selectedStatus === ACTIVE ? activeAlerts : inActiveAlerts)
						.length === limit
				"
				color="#000"
				style="cursor: pointer"
				@click="changeOffset('inc', selectedStatus)"
				>chevron_right</v-icon
			>
		</div>
		<v-dialog v-model="dialogAdd" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Add Notification</span>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field
									label="Title"
									required
									@change="
										val => handleFieldChange(val, 'title')
									"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									label="Body"
									required
									@change="
										val => handleFieldChange(val, 'body')
									"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
					<v-radio-group v-model="selectedType" row>
						<v-radio
							v-for="text in selectionTypes"
							:key="text"
							:label="convertUpperCase(text)"
							:value="text"
							@change="val => handleFieldChange(val, 'alertType')"
						></v-radio>
					</v-radio-group>
					<v-select
						v-if="selectedType === 'roleBased'"
						:items="rolesList"
						label="Roles"
						multiple
						chips
						@change="val => handleFieldChange(val, 'userData')"
					></v-select>
					<v-text-field
						v-if="selectedType === 'userBased'"
						:label="convertUpperCase(selectedType)"
						required
						@change="val => handleFieldChange(val, 'userData')"
					></v-text-field>
					<div class="pa-2">Start Time:</div>
					<div style="display:flex;justify-content: space-between;">
						<v-date-picker
							@change="val => handleFieldChange(val, 'startD')"
							width="250"
						></v-date-picker>
						<v-time-picker
							@change="val => handleFieldChange(val, 'startT')"
							format="24hr"
							width="250"
						></v-time-picker>
					</div>
					<div class="pa-2">End Time:</div>
					<div style="display:flex;justify-content: space-between;">
						<v-date-picker
							@change="val => handleFieldChange(val, 'endD')"
							width="250"
						></v-date-picker>
						<v-time-picker
							@change="val => handleFieldChange(val, 'endT')"
							format="24hr"
							width="250"
						></v-time-picker>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="closeDialog">Close</v-btn>
					<v-btn color="success" flat @click="addRetailAlerts"
						>Save</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<v-dialog v-model="dialogEdit" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Edit Notification</span>
				</v-card-title>
				<v-card-text>
					<div class="pa-2">Start Time:</div>
					<div style="display:flex;justify-content: space-between;">
						<v-date-picker
							@change="
								val => handleFieldChange(val, 'startD', 'edit')
							"
							:value="dialogData.startTime.split('T')[0]"
							width="250"
						></v-date-picker>
						<v-time-picker
							@change="
								val => handleFieldChange(val, 'startT', 'edit')
							"
							format="24hr"
							width="250"
							:value="
								new Date(dialogData.startTime)
									.toTimeString()
									.split(' ')[0]
							"
						></v-time-picker>
					</div>
					<div class="pa-2">End Time:</div>
					<div style="display:flex;justify-content: space-between;">
						<v-date-picker
							@change="
								val => handleFieldChange(val, 'endD', 'edit')
							"
							width="250"
							:value="dialogData.endTime.split('T')[0]"
						></v-date-picker>
						<v-time-picker
							@change="
								val => handleFieldChange(val, 'endT', 'edit')
							"
							format="24hr"
							width="250"
							:value="
								new Date(dialogData.endTime)
									.toTimeString()
									.split(' ')[0]
							"
						></v-time-picker>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="closeDialog">Close</v-btn>
					<v-btn color="success" flat @click="rescheduleAlerts"
						>Save</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<div v-if="isDataLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import {
	FETCH_RETAIL_ALERTS,
	ADD_RETAIL_ALERTS,
	RESCHEDULE_RETAIL_ALERTS
} from "../../store/action-types";

export default {
	name: "NotificationTool",
	data: () => ({
		activeAlerts: [],
		inActiveAlerts: [],
		ACTIVE: "ACTIVE",
		INACTIVE: "INACTIVE",
		selectedStatus: "ACTIVE",
		isDataLoading: false,
		offset: 0,
		limit: 100,
		dialogAdd: false,
		dialogEdit: false,
		dialogData: { startTime: "T", endTime: "T" },
		selectionTypes: ["userBased", "roleBased"],
		selectedType: "userBased",
		payload: { startTime: "T", endTime: "T", alertType: "userBased" },
		rolesList: [
			"Jeet11 captain",
			"Jeet11 captain agency",
			"Jeet11 promoter inshop",
			"Jeet11 promoter outshop",
			"Jeet11 Agent",
			"Jeet11 Retailer",
			"Jeet11 distributor",
			"Jeet11 Executive",
			"Jeet11 shopboy",
			"Jeet11 TSM",
			"Jeet11 RBM"
		],
		roleShopTypeMapping: {
			"Jeet11 captain": { userType: "captain", shopType: null },
			"Jeet11 captain agency": {
				userType: "captain",
				shopType: "agency"
			},
			"Jeet11 promoter inshop": {
				userType: "promoter",
				shopType: "inShop"
			},
			"Jeet11 promoter outshop": {
				userType: "promoter",
				shopType: "outShop"
			},
			"Jeet11 Agent": { userType: "dstrRetail", shopType: "agent" },
			"Jeet11 Retailer": { userType: "dstrRetail", shopType: null },
			"Jeet11 distributor": { userType: "dstr", shopType: null },
			"Jeet11 Executive": { userType: "executive", shopType: null },
			"Jeet11 shopboy": { userType: "dstrRetail", shopType: "shopboy" },
			"Jeet11 TSM": { userType: "tsm", shopType: null },
			"Jeet11 RBM": { userType: "rbm", shopType: null }
		}
	}),
	mounted() {
		this.fetchRetailAlerts(this.ACTIVE);
	},
	methods: {
		fetchRetailAlerts(alertStatus) {
			this.isDataLoading = true;
			this.$store
				.dispatch(FETCH_RETAIL_ALERTS.dispatch, {
					status: alertStatus,
					limit: this.limit,
					offset: this.offset
				})
				.then(data => {
					if (alertStatus === this.ACTIVE)
						this.activeAlerts = data || [];
					else this.inActiveAlerts = data || [];
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		},
		handleChange(status) {
			this.selectedStatus = status;
			this.fetchRetailAlerts(status);
		},
		changeOffset(updateValue, status) {
			if (updateValue === "inc") this.offset += this.limit;
			else this.offset -= this.limit;
			this.fetchRetailAlerts(status);
		},
		openDialog(type, data) {
			if (type === "add") {
				this.dialogAdd = true;
				return;
			}
			this.dialogEdit = true;
			this.dialogData.queryId = data.id;
			this.dialogData.startTime = data.startTime;
			this.dialogData.endTime = data.endTime;
		},
		closeDialog() {
			this.dialogAdd = false;
			this.dialogEdit = false;
		},
		handleFieldChange(val, type, isEdit) {
			if (isEdit) {
				const startTimeArray = this.dialogData.startTime.split("T");
				const endTimeArray = this.dialogData.endTime.split("T");
				if (type === "startD")
					this.dialogData.startTime = new Date(
						`${val} ${startTimeArray[1]}`
					).toISOString();
				else if (type === "endD")
					this.dialogData.endTime = new Date(
						`${val} ${endTimeArray[1]}`
					).toISOString();
				else if (type === "startT")
					this.dialogData.startTime = new Date(
						`${startTimeArray[0]} ${val}`
					).toISOString();
				else if (type === "endT")
					this.dialogData.endTime = new Date(
						`${endTimeArray[0]} ${val}`
					).toISOString();
				return;
			}
			const startTimeArray = this.payload.startTime.split("T");
			const endTimeArray = this.payload.endTime.split("T");
			if (type === "startD")
				this.payload.startTime = val + "T" + startTimeArray[1];
			else if (type === "endD")
				this.payload.endTime = val + "T" + endTimeArray[1];
			else if (type === "startT")
				this.payload.startTime = startTimeArray[0] + "T" + val;
			else if (type === "endT")
				this.payload.endTime = endTimeArray[0] + "T" + val;
			else if (type === "userData") {
				if (this.selectedType === "userBased") {
					this.payload[type] = val.split(",");
				} else {
					this.payload[type] = val.map(
						item => this.roleShopTypeMapping[item]
					);
				}
			} else this.payload[type] = val;
		},
		convertUpperCase(text) {
			return text[0].toUpperCase() + text.substring(1);
		},
		addRetailAlerts() {
			this.isDataLoading = true;
			this.payload.startTime = new Date(
				this.payload.startTime
			).toISOString();
			this.payload.endTime = new Date(this.payload.endTime).toISOString();
			this.$store
				.dispatch(ADD_RETAIL_ALERTS.dispatch, this.payload)
				.then(() => {
					this.closeDialog();
					this.fetchRetailAlerts(this.selectedStatus);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		},
		rescheduleAlerts() {
			this.isDataLoading = true;
			this.$store
				.dispatch(RESCHEDULE_RETAIL_ALERTS.dispatch, this.dialogData)
				.then(() => {
					this.fetchRetailAlerts(this.selectedStatus);
					this.closeDialog();
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
